import Request from './authorized-request';
import Axios from 'axios';

let cancelToken = null;

export default class AccessoriesApi {
  static async fetch(options) {
    if (cancelToken) {
      cancelToken.cancel();
      cancelToken = null;
    }

    cancelToken = Axios.CancelToken.source();

    return Request.get('/accessories', {
      params: {
        ...options,
        limit: null,
      },
      cancelToken: cancelToken.token,
    });
  }

  static async getConfig() {
    return Request.get('/accessories/config');
  }

  static async fetchOne(id) {
    return Request.get(`/accessories/${id}`);
  }

  static async update(data) {
    return Request.put(`/c/accessories/${data.id}`, data);
  }

  static async remove(data) {
    return Request.delete(`/c/accessories/${data.id}`);
  }

  static async create(data) {
    return Request.post(`/c/accessories`, data);
  }
}
